import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux';
import { getInstalacionesByCliente } from '../../../../redux/DucksUnidadInspeccion/AsociadosDuck';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { getClienteByNumsocio } from '../../../../redux/DucksBeneficiario/ClienteDucks';
import SeleccionarInstalacionesComponent from './SeleccionarInstalacionesComponent';
import { obtenerFC_09SolicitudDetalle } from '../../../../redux/DucksBeneficiario/FC_09Ducks';
function SeleccionarDictamenComponent(props) {

    const dispatch = useDispatch();

    const [openSeleccionarInstalaciones, setOpenSeleccionarInstalaciones] = React.useState(false);

    const [cliente, setCliente] = React.useState();

    const [instalacionesCliente, setInstalacionesCliente] = React.useState([]);

    const handleOpenSeleccionarInstalaciones = () => {
        dispatch(getClienteByNumsocio(props.solicitud.numerocliente)).then((rescliente) => {
            setCliente(rescliente.payload.data.data)
            dispatch(getInstalacionesByCliente(rescliente.payload.data.data.idcliente)).then((resinstalaciones) => {
                setInstalacionesCliente(resinstalaciones.payload.data.data)
            })
        })
        setOpenSeleccionarInstalaciones(true)
    }

    const handleCloseSeleccionarInstalaciones = () => {
        setOpenSeleccionarInstalaciones(false)
    }

    const handleGenerarFI04 = () => {
        console.log(props.tipo)
        if (props.tipo == 9) {
            dispatch(getClienteByNumsocio(props.solicitud.numerocliente)).then((rescliente) => {
                console.log(rescliente.payload.data.data)
                let cliente = rescliente.payload.data.data
                dispatch(obtenerFC_09SolicitudDetalle(props.solicitud.idfc09_solicitudcertificado)).then((ressolicitud) => {
                    console.log(ressolicitud.payload.data)

                    let solicitudcompleta = ressolicitud.payload.data

                    var fechaActual = new Date();

                    // Obtiene los componentes de la fecha (año, mes y día)
                    var año = fechaActual.getFullYear();
                    var mes = fechaActual.getMonth() + 1; // ¡Ten en cuenta que los meses se indexan desde 0!
                    var dia = fechaActual.getDate();

                    // Formatea la fecha sin la hora
                    var fechaFormateada = (dia < 10 ? '0' : '') + dia + '/' + (mes < 10 ? '0' : '') + mes + '/' + año;

                    let data = {
                        fechaemision: fechaFormateada,
                        nimforme: "",
                        periodoinspeccion: "",
                        razonsocial: cliente.nombrerazonsocial,
                        domiciliofiscal: "",
                        domicilioinstalacion: "",
                        rfc: cliente.rfc,
                        producto: solicitudcompleta.fc_09_anexoproducto
                    }

                    console.log(data)
                })
            })
        }
    }

    const handleGenerarFI05 = () => {
        console.log(props.tipo)
        if (props.tipo == 9) {
            dispatch(getClienteByNumsocio(props.solicitud.numerocliente)).then((rescliente) => {
                //console.log(rescliente.payload.data.data)
                let cliente = rescliente.payload.data.data
                dispatch(obtenerFC_09SolicitudDetalle(props.solicitud.idfc09_solicitudcertificado)).then((ressolicitud) => {
                    //console.log(props.solicitud)

                    let solicitudcompleta = ressolicitud.payload.data

                    var fechaActual = new Date();

                    // Obtiene los componentes de la fecha (año, mes y día)
                    var año = fechaActual.getFullYear();
                    var mes = fechaActual.getMonth() + 1; // ¡Ten en cuenta que los meses se indexan desde 0!
                    var dia = fechaActual.getDate();

                    // Formatea la fecha sin la hora
                    var fechaFormateada = (dia < 10 ? '0' : '') + dia + '/' + (mes < 10 ? '0' : '') + mes + '/' + año;

                    let data = {
                        fechaemision: fechaFormateada,
                        nsolicitud: props.solicitud.folio,
                        tipoinspeccion: "",
                        periodoinspeccion: "",
                        nimforme: "",
                        ncliente: cliente.numerosocio,
                        razonsocial: cliente.nombrerazonsocial,
                        domiciliofiscal: "",
                        domicilioinstalacion: "",
                        contraseñanom: "",
                        producto: solicitudcompleta.fc_09_anexoproducto
                    }

                    console.log(data)
                })
            })
        }
    }

    const styleSeleccionarInstalaciones = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 900,
        height: 600,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    const modalSeleccionarInstalaciones = () => {
        return (
            <Fragment>
                {
                    <Modal
                        open={openSeleccionarInstalaciones}
                        onClose={handleCloseSeleccionarInstalaciones}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box sx={styleSeleccionarInstalaciones}>
                            <div style={{ textAlign: 'center' }}>
                                <h4>Seleccione las Instalaciones</h4>
                            </div>
                            <SeleccionarInstalacionesComponent tipo={props.tipo} solicitud={props.solicitud} cliente={cliente} instalaciones={instalacionesCliente}></SeleccionarInstalacionesComponent>
                        </Box>

                    </Modal>
                }
            </Fragment>

        )
    }

    return (
        <Fragment >
            <div className="container">
                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <th scope="row">FI-03</th>
                            <td><button className='btn btn-success' onClick={() => { handleOpenSeleccionarInstalaciones() }}>GENERAR</button></td>
                        </tr>
                        <tr>
                            <th scope="row">FI-04</th>
                            <td><button className='btn btn-success' onClick={() => { handleGenerarFI04() }}>GENERAR</button></td>
                        </tr>
                        <tr>
                            <th scope="row">FI-05</th>
                            <td><button className='btn btn-success' onClick={() => { handleGenerarFI05() }}>GENERAR</button></td>
                        </tr>
                        <tr>
                            <th scope="row">FI-06</th>
                            <td><button className='btn btn-success'>GENERAR</button></td>
                        </tr>
                        <tr>
                            <th scope="row">FI-07</th>
                            <td><button className='btn btn-success'>GENERAR</button></td>
                        </tr>
                        <tr>
                            <th scope="row">FI-07</th>
                            <td><button className='btn btn-success'>GENERAR</button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            {modalSeleccionarInstalaciones()}
        </Fragment>

    );
}

export default withRouter(SeleccionarDictamenComponent)